import {Routes} from '@angular/router';
import {TrackersListComponent} from './trackers-list/trackers-list.component';

export const trackersRouting: Routes = [{path: '', component: TrackersListComponent}];
